import { Analysis } from 'common-spectrum';
// @ts-ignore
import { parseXY } from 'xy-parser';
export function fromText(text, options = {}) {
    const { title } = options;
    if (ArrayBuffer.isView(text)) {
        let decoder = new TextDecoder('utf8');
        text = decoder.decode(text);
    }
    const { data, info } = parseXY(text, {
        bestGuess: true,
        keepInfo: true,
        ...options,
    });
    const spectrum = {
        x: {
            data: data.x,
            units: 'm/z',
            label: 'm/z',
        },
        y: {
            data: data.y,
            units: '',
            label: 'Relative intensity',
        },
    };
    let meta = {};
    let index = 1;
    // @ts-ignore
    info.forEach((line) => (meta[`Info ${index++}`] = line.value));
    const analysis = new Analysis();
    analysis.pushSpectrum(spectrum, {
        dataType: 'MASS SPECTRUM',
        title,
        meta,
    });
    return analysis;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZnJvbS9mcm9tVGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDM0MsYUFBYTtBQUNiLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFcEMsTUFBTSxVQUFVLFFBQVEsQ0FBQyxJQUE4QixFQUFFLFVBQWUsRUFBRTtJQUN4RSxNQUFNLEVBQUUsS0FBSyxFQUFFLEdBQUcsT0FBTyxDQUFDO0lBQzFCLElBQUksV0FBVyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUM1QixJQUFJLE9BQU8sR0FBRyxJQUFJLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUN0QyxJQUFJLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUM3QjtJQUVELE1BQU0sRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLEdBQUcsT0FBTyxDQUFDLElBQUksRUFBRTtRQUNuQyxTQUFTLEVBQUUsSUFBSTtRQUNmLFFBQVEsRUFBRSxJQUFJO1FBQ2QsR0FBRyxPQUFPO0tBQ1gsQ0FBQyxDQUFDO0lBRUgsTUFBTSxRQUFRLEdBQUc7UUFDZixDQUFDLEVBQUU7WUFDRCxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDWixLQUFLLEVBQUUsS0FBSztZQUNaLEtBQUssRUFBRSxLQUFLO1NBQ2I7UUFDRCxDQUFDLEVBQUU7WUFDRCxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDWixLQUFLLEVBQUUsRUFBRTtZQUNULEtBQUssRUFBRSxvQkFBb0I7U0FDNUI7S0FDRixDQUFDO0lBQ0YsSUFBSSxJQUFJLEdBQUcsRUFBRSxDQUFDO0lBQ2QsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDO0lBQ2QsYUFBYTtJQUNiLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxJQUFTLEVBQUUsRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLFFBQVEsS0FBSyxFQUFFLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ3BFLE1BQU0sUUFBUSxHQUFHLElBQUksUUFBUSxFQUFFLENBQUM7SUFDaEMsUUFBUSxDQUFDLFlBQVksQ0FBQyxRQUFRLEVBQUU7UUFDOUIsUUFBUSxFQUFFLGVBQWU7UUFDekIsS0FBSztRQUNMLElBQUk7S0FDTCxDQUFDLENBQUM7SUFDSCxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDIn0=